import { PropertiesTagVariant } from '@graftcode/design-system'

import type { BadgeType } from '@/core/utils/getBadgeType'

/** Maps internal badge type to design-system PropertiesTag variant. */
export const getPropertiesTagVariant = (badgeType: BadgeType) => {
  switch (badgeType) {
    case 'class':
      return PropertiesTagVariant.Class
    case 'constructor':
      return PropertiesTagVariant.Constructor
    case 'static-method':
      return PropertiesTagVariant.StaticMethod
    case 'instance-method':
      return PropertiesTagVariant.InstanceMethod
    case 'global-method':
      return PropertiesTagVariant.GlobalMethod
    case 'static-field':
      return PropertiesTagVariant.StaticField
    case 'instance-field':
      return PropertiesTagVariant.InstanceField
    case 'global-field':
      return PropertiesTagVariant.GlobalField
    default:
      return PropertiesTagVariant.Primary
  }
}
